<div class="header">
  <h2>Create Campaign</h2>
</div>
<div class="row">
  <div class="col">
    <mat-card>
      <form [formGroup]="createEventForm" (ngSubmit)="createEvent()">
        <h3 class="sub-heading">Campaign Form</h3>
        <mat-form-field appearance="outline" class="inline-item">
          <mat-label>Title</mat-label>
          <input
            matInput
            formControlName="title"
            placeholder="Title"
            required
          />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="inline-item"
          *ngIf="smtpProviderList?.length > 0"
        >
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required>
            <mat-option [value]="1">Email & Internal Message</mat-option>
            <mat-option [value]="2">Internal Message</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="inline-item"
          *ngIf="
            smtpProviderList?.length > 1 &&
            createEventForm.get('type').value == 1
          "
        >
          <mat-label>Smtp Provider</mat-label>
          <mat-select formControlName="smtp_provider" required>
            <mat-option
              *ngFor="let smtp of smtpProviderList"
              [value]="smtp.id"
              >{{ smtp.provider_name }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="inline-item">
          <mat-label>My Groups</mat-label>
          <mat-select [formControl]="notification_group" multiple>
            <mat-optgroup [label]="'User Groups'">
              <mat-option
                *ngFor="let group of groupList"
                [value]="'g-' + group.id"
                >{{ group.name }}</mat-option
              >
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="inline-item">
          <mat-label>Default Groups</mat-label>
          <mat-select [formControl]="notification_group_default" multiple>
            <mat-optgroup [label]="'Default Groups'">
              <mat-option [value]="'d-0'">All Customers</mat-option>
              <mat-option
                *ngFor="let country of countries"
                [value]="'c-' + country.country_detail.id"
                >{{ country.country_detail.name }} Customers({{
                  country.count
                }})</mat-option
              >
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="inline-item">
          <mat-label>Contact Groups</mat-label>
          <mat-select [formControl]="notification_contact_groups" multiple>
            <mat-optgroup [label]="'Contact Groups'">
              <mat-option
                *ngFor="let contact of contactGroupsList"
                [value]="'cg-' + contact.id"
                >{{ contact.name }}</mat-option
              >
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" class="inline-item">
          <mat-label>Template</mat-label>
          <mat-select formControlName="template">
            <mat-option [value]=""></mat-option>
            <mat-option *ngFor="let template of templateList" [value]="template.id">{{template.title}}</mat-option>
          </mat-select>
        </mat-form-field> -->

        <div>
          <!-- <mat-form-field appearance="outline" class="inline-item">
            <input type="text" placeholder="Select Recipients" aria-label="Select recipients" matInput
              [matAutocomplete]="auto" [formControl]="recipientsControl">
          </mat-form-field>

          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="inline-item">
            <mat-option *ngFor="let customer of filteredCustomers | async" [value]="selectedCustomers">
              <div (click)="optionClicked($event, customer)">
                <mat-checkbox [checked]="customer.selected" (change)="toggleSelection(customer)"
                  (click)="$event.stopPropagation()">
                  {{customer.name}}
                </mat-checkbox>
              </div>
            </mat-option>
          </mat-autocomplete> -->

          <!-- <div class="editor">
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Recipients
                </mat-panel-title>
                <mat-panel-description>
                  Choose Recipients
                </mat-panel-description>
              </mat-expansion-panel-header>
              <form [formGroup]="filterForm" (ngSubmit)="onSubmitFilterForm()">
                <mat-form-field appearance="outline" class="inline-item">
                  <mat-label>country</mat-label>
                  <mat-select formControlName="city__state__country">
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngFor="let country of countries" [value]="country.id">
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="inline-item">
                  <mat-label>office</mat-label>
                  <mat-select formControlName="office">
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngFor="let office of officesList" [value]="office.id">
                      {{ office.title }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="inline-item">
                  <mat-label>Search</mat-label>
                  <input matInput formControlName="search" placeholder="search recipients" />
                </mat-form-field>
                <button mat-flat-button type="submit" color="primary">Filter Recipients</button>
              </form>
              <div class="table-container mat-elevation-z0">

                <table mat-table [dataSource]="customerList" matTableResponsive>
                  <ng-container matColumnDef="checkbox">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let customer">
                      <mat-checkbox [checked]="isCustomerSelected(customer.is)" (change)="toggleSelection(customer)"
                        (click)="$event.stopPropagation()">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef> No. </th>
                    <td mat-cell *matCellDef="let i=index"> {{ i + 1}} </td>
                  </ng-container>

                  <ng-container matColumnDef="customerCode">
                    <th mat-header-cell *matHeaderCellDef> Customer Code </th>
                    <td mat-cell *matCellDef="let customer"> {{customer.code}}</td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let customer"> <span
                        class="company">{{customer.company | slice:0:20}}<span
                          *ngIf="customer.company?.length > 20">...</span></span></td>
                  </ng-container>


                  <tr mat-header-row *matHeaderRowDef="customersDisplayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: customersDisplayedColumns;"></tr>
                </table>
              </div>
            </mat-expansion-panel>
          </div> -->
        </div>
        <!-- <h3 class="sub-heading">Subject</h3> -->
        <div class="subject-wrapper">
          <mat-form-field
            appearance="outline"
            class="inline-item subject-field"
          >
            <mat-label>Subject</mat-label>
            <input
              matInput
              formControlName="subject"
              placeholder="Subject"
              required
            />
          </mat-form-field>
          <div>
            <button
              mat-flat-button
              type="submit"
              color="primary"
              [disabled]="
                createEventForm.invalid ||
                (!notification_group.value.length &&
                  !notification_group_default.value.length &&
                  !notification_contact_groups.value.length)
              "
            >
              Create
            </button>
          </div>
        </div>
        <mat-form-field appearance="outline" class="inline-item">
          <mat-label>templates</mat-label>
          <mat-select [formControl]="template_field">
            <mat-option
              *ngFor="let template of templates.default"
              [value]="template"
              >{{ template.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <div class="editor">
          <ckeditor
            [editor]="editor"
            formControlName="content"
            (ready)="onReady($event)"
            [config]="config"
          >
          </ckeditor>
          <div></div>
        </div>
        <br />
        <div class="inline-item">
          <h3 class="sub-heading">Attachment(s)</h3>
          <div (click)="openFileField()" class="icon">
            <mat-icon> attach_file</mat-icon>
            <span> Add attachment </span>
          </div>
          <input
            type="file"
            id="file"
            (change)="onUpload($event)"
            accept=".pdf, .doc, .docx, .jpg,.png,.xlsx,.xls,.mp3"
            class="hidden-field"
          />
          <br />
        </div>
        <div class="choosed-files inline-item">
          <div *ngIf="files">
            <div *ngFor="let file of files; let i = index" class="file">
              <p>{{ file.name }}</p>
              <button mat-icon-button>
                <mat-icon
                  (click)="removeFile(i)"
                  matSuffix
                  color="accent"
                  class="icon"
                >
                  remove_circle
                </mat-icon>
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card>
  </div>
</div>
